import { HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { API_CONFIG, ApiCallingV2Service } from '@zayan-erp/shared';

import { EmailLogDetails, EmailLogFilters, EmailLogPage } from '../models/email-log.models';

const EMPTY_PAGE: EmailLogPage = { items: [], totalCount: 0 };

@Injectable({
  providedIn: 'root'
})
export class EmailLogService {
  readonly #http = inject(ApiCallingV2Service);
  readonly #baseUrl = `${inject(API_CONFIG).baseUrlV2}/email-log`;

  /**
   * Newest first, with a real total count. `IsValidDateRange` is not sent: the backend computes it.
   */
  getPage(filters: EmailLogFilters, pageNumber: number, pageSize: number): Observable<EmailLogPage> {
    let params = new HttpParams().set('PageNumber', pageNumber).set('PageSize', pageSize);

    if (filters.fromDate) params = params.set('FromDate', filters.fromDate);
    if (filters.toDate) params = params.set('ToDate', filters.toDate);
    if (filters.status) params = params.set('Status', filters.status);
    if (filters.actionName) params = params.set('ActionName', filters.actionName);
    if (filters.smtpConfigurationId) params = params.set('SmtpConfigurationId', filters.smtpConfigurationId);
    if (filters.search) params = params.set('Search', filters.search);

    return this.#http
      .getData<EmailLogPage>(this.#baseUrl, {
        showLoader: false,
        showMessage: false,
        options: { params }
      })
      .pipe(map((response: EmailLogPage | null) => response ?? EMPTY_PAGE));
  }

  getDetails(id: string): Observable<EmailLogDetails> {
    return this.#http.getData<EmailLogDetails>(`${this.#baseUrl}/${id}`, {
      showLoader: false,
      showMessage: false
    });
  }
}
